import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import CardContent from '@material-ui/core/CardContent';
import yellow from '@material-ui/core/colors/yellow';
import { shallowEqual } from 'app-source/utils/shallowEqual';

const circle = {
  content: '""',
  backgroundColor: yellow[500],
  width: 13,
  height: 13,
  position: 'absolute',
  borderRadius: '50%',
};

const styles = () => ({
  content: {
    marginTop: 50,
    marginBottom: 20,
    marginLeft: 13,
    marginRight: 13,
  },
  bar: {
    height: 2,
    backgroundColor: yellow[500],
    position: 'relative',
    color: '#000000',
    '&:before': {
      ...circle,
      top: -6,
      left: -7,
    },
    '&:after': {
      ...circle,
      top: -6,
      right: -7,
    },
    '& > div': {
      position: 'absolute',
      top: -56,
      '& > div': {
        // chip component
        fontSize: '0.7rem',
        lineHeight: '1.2rem',
        backgroundColor: yellow[500],
        marginLeft: '-50%',
        '&:after': {
          ...circle,
          bottom: -27,
        },
      },
    },
  },
});

class TriviaRankingContentComponent extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    userRanking: PropTypes.shape({
      position: PropTypes.number.isRequired,
      of: PropTypes.number.isRequired,
    }).isRequired,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this, nextProps, nextState, {
      propsSelectOptions: { omit: ['classes'] },
    });
  }

  render() {
    const { classes, userRanking } = this.props;

    const left = `${((userRanking.position - 1) * 100) / (userRanking.of - 1)}%`;

    return (
      <CardContent className={classes.content}>
        <div className={classes.bar}>
          <div style={{ left }}>
            <Chip label={userRanking.position} />
          </div>
        </div>
      </CardContent>
    );
  }
}

export const TriviaRankingContent = withStyles(styles)(TriviaRankingContentComponent);
